import { User } from '../../config/api/models/User';
import { GroupStudent } from '../../config/api/models/Group';

export const getInitials = (user: User | GroupStudent) =>
  `${(user.firstName || '').substring(0, 1)}${(user.name || '').substring(0, 1)}`;
